import apiClient from './api';

async function fetchAll(data) {
  try {
    const response = await apiClient.get('/get-servicegroups', data || {}); // Replace with your endpoint
    return response;
  } catch (error) {
    console.error('Error fetching all groups:', error);
    throw error;
  }
}

async function createOrUpdate(data) {
  try {
    const response = await apiClient.post('/create-update-servicegroup', data);
    return response;
  } catch (error) {
    console.error('Error creating or updating group:', error);
    throw error;
  }
}

async function massArchiveGroups(data) {
  data.field = 'deleted_at';
  data.value = new Date().toISOString().replace('T', ' ').substr(0, 19);
  try {
    const response = await apiClient.post('/mass-update-servicegroups', data);
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function get(params) {
  try {
    const response = await apiClient.get('/get-servicegroup', { params });
    return response;
  } catch (error) {
    console.error('Error fetching group:', error);
    throw error;
  }
}

export { fetchAll, createOrUpdate, get, massArchiveGroups };
